import { Card, Row } from "@masterteam/mt-design-react";
import React from "react";
import { FormattedMessage } from "react-intl";

import DoughnutChart from "../../../DoughnutChart";
import KPIStatusIndicator from "../../../KPIStatusIndicator";

import { ReactComponent as ChartIcon } from "../../../../assets/images/bar-chart.svg";

import "./style.scss";

const SummaryCard = ({
  data,
  title,
  detailsTitle,
  detailsData,
  statuses,
  totalCount,
  detailsGroupedByObjectives,
  isProject = false,
  systemStatuses = null,
  isInitiative = false,
  levels
}) => {
  return (
    <Card className="summary-card">
      <Row className="summary-card__title" align="center" gap={8}>
        <ChartIcon />
        <FormattedMessage id={title} />
      </Row>

      <Row className="summary-card_chart" justify="center">
        <DoughnutChart
          data={data || []}
          statuses={statuses}
          count={totalCount}
          detailsTitle={detailsTitle}
          detailsData={detailsData}
          showNoData
          detailsGroupedByObjectives={detailsGroupedByObjectives}
          isProject={isProject}
          isInitiative={isInitiative}
          levels={levels}
          staticPlannedColor="#007DC5"
        />
      </Row>

      <Row
        className="summary-card__statuses"
        justify="center"
        size="medium"
        wrap
      >
        {(systemStatuses ? systemStatuses : statuses).map((_item, index) => (
          <KPIStatusIndicator item={_item} key={index} />
        ))}
      </Row>
    </Card>
  );
};

export default SummaryCard;
